import { DocumentLanguage } from "@/modules/patients/libs/document-languages"

const DOCUMENT_LANGUAGES: Array<{ value: DocumentLanguage; label: string }> = [
  { value: "GERMAN", label: "common.languageList.german" },
  { value: "FRENCH", label: "common.languageList.french" },
]

export { DOCUMENT_LANGUAGES }
